import { MouseEventHandler } from "react";
import styled, { css } from "styled-components";
import RouterLink from "redux-first-router-link";
import { Flex, IconButton, IconButtonButton, transition } from "@evergis/ui";

export const Container = styled(Flex)`
  align-items: stretch;
  flex-direction: column;
  height: 100%;
`;

export const NavContainer = styled.div`
  padding: 1.5rem 1.5rem 1rem;
`;

export const ChildCategoryOption = styled(Flex)`
  align-items: center;
`;

export const ChildCategoryIcon = styled.div`
  width: 1.5rem;
  margin-right: 0.5rem;

  path {
    fill: ${({ theme: { palette } }) => palette.icon};
  }
`;

export const NavToolsContainer = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  min-height: 2rem;
  margin-top: 0.75rem;

  ${IconButtonButton} {
    font-size: 0.75rem;

    ${ChildCategoryIcon} {
      width: 1.25rem;
      margin-right: 0.25rem;
      margin-top: -0.2rem;

      path {
        fill: ${({ theme: { palette } }) => palette.primary};
      }
    }

    > * {
      color: ${({ theme: { palette } }) => palette.primary};
    }

    &:hover > * {
      color: ${({ theme: { palette } }) => palette.primaryDark};
    }
  }
`;

const ActiveCategoryMixin = css`
  background-color: ${({ theme: { palette } }) => palette.primary};
  border-radius: 50%;

  span[kind]:after {
    color: #fff;
  }
`;

export const CategoryButton = styled(IconButton)<{ active?: boolean }>`
  margin: 0 0.25rem;
  padding: 0.5rem;
  ${({ active }) => active && ActiveCategoryMixin};

  span[kind] {
    display: flex;
    align-items: center;

    &:after {
      font-size: 0.875rem;
    }
  }

  &:first-child {
    padding: 0.55rem;

    span[kind]:after {
      font-size: 0.7rem;
    }
  }
`;

export const ListContainer = styled(Flex)`
  flex: 1;
  justify-content: center;
  align-content: flex-start;

  > * {
    border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  }
`;

const SymbolButtonWithClick = css`
  cursor: pointer;
  width: 3.875rem;
  height: 3.875rem;

  &:hover {
    background-color: ${({ theme: { palette } }) => palette.elementDeep};
  }
`;

export const SymbolButton = styled.span<{ onClick?: MouseEventHandler<HTMLSpanElement> | null }>`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color ${transition.hover};
  ${({ onClick }) => !!onClick && SymbolButtonWithClick};

  svg {
    max-width: 4rem;
    max-height: 4rem;
  }
`;

export const FooterButton = styled(RouterLink)`
  align-self: center;
  margin: 0.5rem 0;
  font-size: 0.75rem;
  text-decoration: none;
`;

export const AnalyticNavImg = styled.div`
  height: 2.5rem;
  padding: 1rem;
  text-align: center;
`;

export const AnalyticNavTitle = styled.div`
  padding: 0 0.5rem;
  text-align: center;
  font-size: 0.75rem;
`;

export const AnalyticNavItem = styled.div<{ isDisabled: boolean }>`
  cursor: ${({ isDisabled }) => (isDisabled ? "default" : "pointer")};
  width: 25%;
  height: 6.25rem;
  padding-bottom: 0.5rem;
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  transition: background-color ${transition.hover};

  &:hover {
    background-color: ${({ theme: { palette } }) => palette.elementDark};
  }

  ${AnalyticNavTitle} {
    color: ${({ theme: { palette }, isDisabled }) => (isDisabled ? palette.iconDisabled : palette.textSecondary)};
  }
`;
